export const IN_TRIAL = 'in_trial';
export const ACTIVE = 'active';
export const NON_RENEWING = 'non_renewing';
export const PAUSED = 'paused';
export const CANCELLED = 'cancelled';
